import { __decorate, __extends } from "tslib";
import { ThresholdTask } from './tasks/ThresholdTask';
import { FilterBase } from './FilterBase';
import { proxyTo } from '../utils/FilterUtils';
var ThresholdFilter = /** @class */ (function (_super) {
    __extends(ThresholdFilter, _super);
    /**
     * Creates a new ThresholdFilter3D object
     * @param blurX The amount of horizontal blur to apply
     * @param blurY The amount of vertical blur to apply
     * @param stepSize The distance between samples. Set to -1 to autodetect with acceptable quality.
     */
    function ThresholdFilter() {
        var _this = _super.call(this) || this;
        _this._thresholdTask = new ThresholdTask();
        _this.addTask(_this._thresholdTask);
        return _this;
    }
    __decorate([
        proxyTo('_thresholdTask')
    ], ThresholdFilter.prototype, "mapPoint", void 0);
    __decorate([
        proxyTo('_thresholdTask')
    ], ThresholdFilter.prototype, "bitmap", void 0);
    __decorate([
        proxyTo('_thresholdTask')
    ], ThresholdFilter.prototype, "operation", void 0);
    __decorate([
        proxyTo('_thresholdTask')
    ], ThresholdFilter.prototype, "color", void 0);
    __decorate([
        proxyTo('_thresholdTask')
    ], ThresholdFilter.prototype, "mask", void 0);
    __decorate([
        proxyTo('_thresholdTask')
    ], ThresholdFilter.prototype, "copySource", void 0);
    __decorate([
        proxyTo('_thresholdTask')
    ], ThresholdFilter.prototype, "threshold", void 0);
    return ThresholdFilter;
}(FilterBase));
export { ThresholdFilter };
